<template>
    <div>
        <v-dialog persistent v-model="dialog" width="520px">
            <v-card width="850px">
                <v-card-title style="background: #455a64; color: white">
                    <span class="overline font-weight-black">カラー配置図依頼</span>
                </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-col cols="11" class="mt-4 ml-3 pa-0"><span style="font-size:18px;font-family:Arial, Helvetica, sans-serif;">屋外配管経路図を配置図に反映 【トライアル】</span></v-col>
                            <v-radio-group  hide-details row v-model="newSiteDiagram" class="ml-12">
                                <v-radio label="あり" value="あり"></v-radio>
                                <v-radio label="なし" value="なし"></v-radio>  
                            </v-radio-group>
                        
                            <v-col cols="10" class="mt-4 ml-2 pa-0">
                                <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※BOSSに屋外配管経路図アップロード済み</span>
                            </v-col>
                            <div class="ml-2" style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※1回のみ依頼可能。依頼後、修正が必要な場合は配置図に指示。</div>
                            <div class="ml-2" style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※トライアルエリア以外での依頼は不可</div>

                            <!-- <v-radio-group v-model="newBossRadio" hide-details column class="ml-12">
                                <v-radio label="BOSS送信済み" value="1"></v-radio>
                                <v-radio label="CAD依頼添付資料に添付" value="2"></v-radio>
                            </v-radio-group> -->
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="cancelNewSubmit">キャンセル</v-btn>
                        <v-btn dark color="green" @click="submitNewSiteLayout">保存</v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        dialog : Boolean
    },
    data: () => ({
        newSiteDiagram : 'なし',
        // newBossRadio : null,

    }),

    computed: {
        ...mapState([
            'editMode',
            'editCadRequestRevisionContent',
        ])
    },

    methods: {
        toggleDialogNewSiteLayout(value){
            this.$emit('toggleDialogNewSiteLayout', value)
        },

        submitNewSiteLayout(){
            this.$emit('submitNewSiteLayout', {
                newSiteDiagram : this.newSiteDiagram,
                // newBossRadio : this.newBossRadio
            }),
            this.toggleDialogNewSiteLayout(false)
        },

        cancelNewSubmit(){
            if(!this.editMode){
                this.newSiteDiagram = 'なし',
                // this.newBossRadio = null
                this.$emit('cancelNewSubmit', null)
                this.toggleDialogNewSiteLayout(false)
            } else {
                this.toggleDialogNewSiteLayout(false)
            }
        },
    },

    watch: {
        "$store.state.editCadRequestRevisionContent"(val){
            this.newSiteDiagram = val.new_site_diagram
        }
    }


}

</script>